<template>
  <div class="exam_contain">
    <div class="exam_select_flex">
      <div class="exam_select_box">
        <div class="exam_select_item">
          <span>用户信息：</span>
          <el-input v-model="filtrate.keyword" placeholder="可搜索姓名、手机号码或证件号码"></el-input>
        </div>
        <el-button type="primary" @click="searchUserInfo()">查询</el-button>
      </div>
    </div>
   
    <!-- 表格 -->
    <div class="table_wrapper">
      <div class="table_content">
        <el-table 
          border 
          :data="infoList" 
          max-height="700"
          :row-key="getRowKeys"
          @selection-change="handleSelectionChange"
          stripe
        >
          <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
          <el-table-column prop="serial" width="60" label="序号"></el-table-column>
          <el-table-column prop="realName" width="120" label="姓名"></el-table-column>
          <el-table-column prop="nickName" width="140" label="昵称"></el-table-column>
          <el-table-column prop="sex" width="80" label="性别"></el-table-column>
          <el-table-column prop="mobilePhone" width="160" label="手机号"></el-table-column>
          <el-table-column prop="cardNo" width="220" label="证件号"></el-table-column>
          <el-table-column prop="updateTime" width="200" label="上次修改时间"></el-table-column>
          <el-table-column  label="操作">
             <template slot-scope="{row}">
              <div class="table_content_operation">
                <!-- 查看考生信息 -->
                <el-tooltip class="item" effect="dark" content="查看信息" placement="bottom">
                  <img 
                    class="operation_img" 
                    @click="studentInfoPreview(row.id)" 
                    src="@/assets/image/batchSignUp/icon_check.png"/>
                </el-tooltip>
                <!-- 编辑考生信息 -->
                <el-tooltip class="item" effect="dark" content="编辑修改" placement="bottom">
                  <img 
                    class="operation_img" 
                    @click="studentInfoEdit(row.id)" 
                    src="@/assets/image/batchSignUp/icon_edit.png" />
                </el-tooltip>
                
                
              </div>
            </template> 
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="page_footer">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="filtrate.page"
        :page-sizes="[12, 24, 48, 360]"
        :page-size="filtrate.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="listCount">
      </el-pagination>
    </div>
 
    
  </div>
</template>
 
<script>
export default {
  data() {
    return {
      selected: [],  //选中的数据
      filtrate: {
        keyword: '',
        page: 1,
        size: 12,
      },
      listCount:0,
      infoList:[]
    }
  },
  created() {
    this.getUserInfo()
  },
  methods: {
    getUserInfo:function(){     //获取用户信息
      this.$http.get('/user/management',{params:this.filtrate}).then(res => {
        if(res.data.success){
          this.infoList = res.data.data.list || []
          this.listCount = res.data.data.count
          if(this.infoList.length){
              this.infoList.forEach((element,index) => {
              element.serial = (this.filtrate.page - 1 ) * this.filtrate.size + ( index + 1)
              element.updateTime = this.$moment(element.updateTime).format('YYYY-MM-DD HH:mm:ss')
              
              if(element.sex === 'male'){
                element.sex = '男'
              }else if(element.sex === 'female'){
                element.sex = '女'
              }
            })
          }
        }
      })
    },
    searchUserInfo:function(){
      this.filtrate.page = 1
      this.getUserInfo()
    },
    handleSelectionChange:function(){

    },
    getRowKeys(row) {
      return row.id + row.serial;
    },

    handleSizeChange(val) {
      this.filtrate.page = 1
      this.filtrate.size = val
      this.getUserInfo()
    },
    handleCurrentChange(val) {
      this.filtrate.page = val
      this.getUserInfo()
    },
    studentInfoPreview(id){
      this.$router.push(`/userManage/${id}/preview`)
    },
    studentInfoEdit(id){
      this.$router.push(`/userManage/${id}/edit`)
    }
  }
}
</script>
 
<style lang="less" scoped>
.exam_contain {
  min-width: 1290PX;
  box-sizing: border-box;
}
.exam_contain {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: @whitee;
  width: 100%;
  padding: 30px;
  overflow: auto;
  height: 100vh;
}
.exam_button_box {
  display: flex;
  justify-content: flex-end;
  margin: 40px 0;
}
.exam_button_box button {
  width: 200px;
  height: 80px;
  margin: 0 20px 0 0;
}
.page_footer{
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  .van-pagination{
    margin: 0 20px;
  }
}
.operation_img {
  width: 25PX !important;
  height: 25PX !important;
  display: block;
  margin: 0 3PX
}
.exam_select_flex {
  display: flex;
  flex-direction: column;
  margin:30PX 0 0 40PX;
}
.exam_select_box{
  width: 100%;
  display: flex;
  justify-content: flex-start;
  margin-top: 50px;
}
.exam_select_item{
  white-space: nowrap;
  width: 650px;
  display: flex;
  align-items: center;
  margin-right: 40px;
 
}
.table_wrapper {
  flex: 1;
  width: 100%;
  margin:60PX 0 0 0;
  height: 700PX;
  position: relative;
  .table_content {
    position: absolute;
    width: 100%;
    margin: 0;
    .table_content_operation{
      display: flex;
      justify-content: center;
    }
  }
}
/deep/ .has-gutter{
  color: black;
}
/deep/ .cell {
  text-align: center;
  padding: 0 10px !important;
}
/deep/ .el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell{
  background: #F0F5FA;
}
::v-deep .is-loading {
  color: white;
}
::v-deep .el-dialog {
    position: relative;
    margin: 0 auto 50px;
    background: #FFF;
    border-radius: 2px;
    box-shadow: 0 1px 3px rgb(0 0 0 / 30%);
    box-sizing: border-box;
    width: 50%;   // 改变对话框 宽度的大小，就可以调整表格的宽度了(尤其是 操作那一列的宽度)
}
</style> 

